import { useMoveToPhotoReviewList } from './useMoveToPhotoReviewList';
import { useMoveToReviewList } from './useMoveToReviewList';

export const useReviewsNavigator = () => {
  const moveToPhotoReviewList = useMoveToPhotoReviewList();
  const moveToReviewList = useMoveToReviewList();

  return { moveToPhotoReviewList, moveToReviewList };
};
